import { useEffect } from 'react'
import { createUseStyles } from 'react-jss'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { filterChanged, pageIndexChanged } from '../../redux/slices/creditFacilityPayoutSlice'
import useDidUpdateEffect from '../../hooks/useDidUpdateEffect'
import CreditFacilityPayoutList from './CreditFacilityPayoutList'
import CreditFacilityPayoutFilter from './CreditFacilityPayoutFilter'
import useCreditFacilityPayoutActions from '../../hooks/useCreditFacilityPayoutActions'

export interface Props {
    payoutCreditFacilityId?: string
  }

const CreditFacilityPayoutListComponent = ({ payoutCreditFacilityId }: Props) => {
  const styles = useStyles()
  const dispatch = useAppDispatch()
  const { getCreditFacilityPayouts } = useCreditFacilityPayoutActions()

  const payoutsOnPage = useAppSelector(state => state.creditFacilityPayout.payoutsOnPage)
  const totalCount = useAppSelector(state => state.creditFacilityPayout.totalCount)
  const searchTerm = useAppSelector(state => state.creditFacilityPayout.searchTerm)
  const searchPayoutCreditFacilityId = useAppSelector(state => state.creditFacilityPayout.payoutCreditFacilityId)
  const pageIndex = useAppSelector(state => state.creditFacilityPayout.pageIndex)
  const pageSize = useAppSelector(state => state.creditFacilityPayout.pageSize)

  useEffect(() => {
    if (payoutCreditFacilityId && payoutCreditFacilityId !== searchPayoutCreditFacilityId)
      dispatch(filterChanged({ searchTerm: '', payoutCreditFacilityId: payoutCreditFacilityId as string}))
  }, [payoutCreditFacilityId, searchPayoutCreditFacilityId])

  useDidUpdateEffect(() => {
    if (searchPayoutCreditFacilityId) {
      getCreditFacilityPayouts(searchPayoutCreditFacilityId, searchTerm ?? '', pageIndex, pageSize)
    }
  }, [searchPayoutCreditFacilityId, pageIndex, searchTerm])

  const onPageChange = (pageIndex: number) => {
    dispatch(pageIndexChanged(pageIndex))
  }

  const onFilterChange = (value: string) => {
    dispatch(filterChanged({ searchTerm: value.toLowerCase(), payoutCreditFacilityId: payoutCreditFacilityId as string}))
  }

  return (
      <div className={styles.container}>
        <CreditFacilityPayoutFilter
          filterValue={searchTerm || ''}
          onFilterChange={onFilterChange}
        />
        <CreditFacilityPayoutList
          payoutCreditFacilityId={payoutCreditFacilityId ?? ''}
          payoutsOnPage={payoutsOnPage}
          pageIndex={pageIndex}
          pageSize={pageSize}
          totalCount={totalCount}
          onPageChange={onPageChange}
        />
      </div>
    )
}

export default CreditFacilityPayoutListComponent

const useStyles = createUseStyles({
  container: {
      marginTop: 40,
  }
})
